import { HttpClient, HttpResponseBase } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, throwError as _observableThrow } from 'rxjs'
import {
    catchError as _observableCatch,
    mergeMap as _observableMergeMap,
} from 'rxjs/operators'

import { BaseService } from '../shared/base.service'
import { MainService } from '../shared/main.service'
import { API, HANDSHAKE } from '../utils/constants'
import { OptionsType } from '../utils/handshake.model'
import { ConfigService } from './config.service'

@Injectable({
    providedIn: 'root',
})
export class MultiStepService {

    isHandShakeFlg: boolean;
    API_URL: string;

    constructor(
        private http: HttpClient,
        private mainService: MainService,
        private baseService: BaseService,
        private configSevice: ConfigService
    ) {
        this.isHandShakeFlg = this.configSevice.get(HANDSHAKE);
        this.API_URL = this.configSevice.get(API);
    }

    // check
    getFieldCreateForm(input: any): Observable<any> {
        let url_ = this.API_URL + 'MultiStep/GetFieldCreateForm';
        url_ = url_.replace(/[?&]$/, "");

        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }

            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url_,
            input,
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    // getListFieldOptions
    getListFieldOptions(input: any): Observable<any> {
        let url_ = this.API_URL + 'MultiStep/GetListFieldOptions';
        url_ = url_.replace(/[?&]$/, "");

        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }

            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url_,
            input,
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    // getFormByCode
    getFormByCode(input: any): Observable<any> {
        let url_ = this.API_URL + 'MultiStep/GetFormByCode';
        url_ = url_.replace(/[?&]$/, "");

        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }

            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url_,
            input,
            null,
            func,
            this.isHandShakeFlg,
        )
    }

}